module.exports = __webpack_public_path__ + "static/img/shopLogin.6654499.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shopLogin.png
// module id = 3136
// module chunks = 1